import { render, staticRenderFns } from "./ecosystem-switcher-modal.vue?vue&type=template&id=55e13d2e&"
import script from "./ecosystem-switcher-modal.ts?vue&type=script&lang=js&"
export * from "./ecosystem-switcher-modal.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports